import React from 'react';
import { useHistory } from 'react-router-dom';
import { Visibility, Edit } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { LinearProgress } from '@mui/material';
import encodeBase64 from '../../../utils/encodeBase64';
import '../../../stylesheets/stylesLayout/cardHotelProperties.scss';
import useUserProfile from '../../../customHooks/useUserProfile';
import Tooltip from '../../../muiComponents/Tooltip';
import Card from '../../../muiComponents/Card';
import Icon from '../../../muiComponents/Icon';
import Image from '../../components/Image';
import Status from '../../../components/Status';
import useTranslate from '../../../customHooks/useTranslate';
import { commonIcons } from '../../../utils/commonVariables/commonIcons';

interface PropertyCardProps {
    hotelName: string;
    src: string;
    progress: number;
    id: string;
    status: string;
    statusColor: string;
}

function PropertyCard({
    hotelName,
    src,
    progress,
    id,
    status,
    statusColor,
}: PropertyCardProps) {
    const history = useHistory();
    const translate = useTranslate();
    const IdEncode = encodeBase64(id);
    const { readOnlyUser } = useUserProfile();

    const handleEditHotel = () => {
        history.push(`/your-property/${IdEncode}`);
    };

    return (
        <Card className='card__property__container' onClick={handleEditHotel}>
            <div className='card__property__container--image'>
                <div className='card__property__container--edit'>
                    <IconButton
                        onClick={handleEditHotel}
                        aria-label='edit'
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                            backgroundColor: `var(--background-transparent-50)`,
                        }}
                        size='small'
                    >
                        {readOnlyUser ? <Visibility /> : <Edit />}
                    </IconButton>
                </div>
                {src ? (
                    <Image
                        alt='hotel image'
                        className='hotel__image'
                        src={src}
                        useLocalBaseUrl={false}
                    />
                ) : (
                    <div className='hotel__image__placeholder-container'>
                        <Icon
                            iconName={commonIcons.HOTEL}
                            className='hotel__image__placeholder'
                        />
                    </div>
                )}
            </div>
            <Tooltip title={`${progress}% ${translate('completed')}`}>
                <LinearProgress
                    className='margin-block-16'
                    variant='determinate'
                    value={progress}
                />
            </Tooltip>
            <div className='card__property__container--name__hotel flex-grow'>
                <div className='flex-grow'>
                    <Tooltip title={hotelName}>
                        <h5 className='multiline-overflow__2 text-secondary-700'>
                            {hotelName}
                        </h5>
                    </Tooltip>
                </div>

                <Tooltip titleText={'status'}>
                    <span className='width-content'>
                        <Status text={status} color={statusColor} />
                    </span>
                </Tooltip>
            </div>
        </Card>
    );
}

export default PropertyCard;
